import Vue from 'vue'
import Router from 'vue-router'
import Zpevnik from "@/views/Zpevnik"
import Session from "@/views/Session"
import Export from "@/views/Export";

Vue.use(Router);

export default new Router({
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			name: "zpevnik",
			component: Zpevnik
		},
		{
			path: "/song/:song",
			name: "zpevnik-song",
			component: Zpevnik
		},
		{
			path: "/session/:session",
			name: "session",
			component: Session
		},
		{
			path: "/export/:song",
			name: "export-song",
			component: Export
		}
	]
})
